/*!
 * AudoChat - Footer Component
 */

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";

function Footer() {
  return (
    <VuiBox
      display="flex"
      flexDirection={{ xs: "column", lg: "row" }}
      justifyContent="space-between"
      direction="row"
      component="footer"
      py={2}
      pb={0}
    >
      <VuiBox item xs={12} sx={{ textAlign: "center" }}>
        {/* Footer content removed */}
      </VuiBox>
    </VuiBox>
  );
}

export default Footer;
